

export class TimesheetReportService {
    static data = [];
    //Note: Will remove after Integration
    // Static Data
    // {
    //     "id": "63aae57a79c4f1b2b9c431cf",
    //     "customer": "abcd-efgh-ijkl",
    //     "projectId": "63aabe567924f93824333b5d",
    //     "projectName": "project1",
    //     "projectCode": "proj-1",
    //     "jobId": "63aabe697924f93824333b5f",
    //     "jobName": "job1",
    //     "fromDate": "2022-12-16T09:04:00Z",
    //     "toDate": "2022-12-16T10:04:00Z",
    //     "employeeId": TenantService.get(TENANT.USER_ID),
    //     "employeeName": "Shrey Achhreja",
    //     "status": "SUBMITTED",
    //     "isBillable": true,
    //     "seconds": 3600,
    //     "ratePerHour": 0,
    //     "amount": 0
    // }
}